import * as React from "react";
import { Modal } from "@traceair/tds";
import { i18nKeys, t } from "../../i18n/i18n";
import { style } from "typestyle";
import { FunctionComponent, useEffect, useState } from "react";
import trackAction from "../../libs/analytics/SigninPageAnalytics";
import { getLoginService } from "../../login-service/LoginService";
import {
  LoginServiceError,
  LoginServiceErrorCode
} from "../../login-service/LoginServiceErrors";
import redirectToApp from "../redirect-to-app";
import { History } from "history";

export type TermsOfUse = {
  url: string;
  dateAdded: string;
};

interface ITermsOfUsePageProps {
  termsOfUse: TermsOfUse;
  refererUrl: string;
  history: History;
}

export const TermsOfUsePage: FunctionComponent<ITermsOfUsePageProps> = ({
  termsOfUse,
  refererUrl,
  history
}) => {
  // redirect on root page if user is not logged in
  useEffect(() => {
    (async () => {
      try {
        await getLoginService().ensureUserLoggedIn();
      } catch (err) {
        const response = err.response;
        if (response && response.status === 401) {
          history.push("/");
          return;
        }
      }
    })();
  }, []);

  const [pending, setPending] = useState(false);
  const handleAgree = () => {
    setPending(true);

    getLoginService()
      .agreeTermsOfUse(termsOfUse.dateAdded)
      .then(() => {
        trackAction("Login page - Terms of use agreed");
        redirectToApp(refererUrl);
      })
      .catch((error: LoginServiceError) => {
        setPending(false);
        if (error.code === LoginServiceErrorCode.TOU_DATE_MISMATCH) {
          location.reload();
          return;
        }
        if (error.code === LoginServiceErrorCode.UNAUTHORIZED) {
          history.push("/");
          return;
        }
        throw error;
      });
  };

  const handleDecline = async () => {
    trackAction("Login page - Terms of use declined");
    await getLoginService()
      .logout()
      .catch(() => {});
    history.push("/");
  };

  return (
    <Modal
      isOpen={true}
      size="l"
      title={t(i18nKeys.termsOfUseTitle)}
      description={t(i18nKeys.termsOfUseDescription)}
      loading={pending}
      cancelButtonProps={{
        text: t(i18nKeys.decline),
        onClick: handleDecline
      }}
      okButtonProps={{
        text: t(i18nKeys.acceptAndContinue),
        onClick: handleAgree
      }}
    >
      <iframe
        src={termsOfUse.url}
        title={t(i18nKeys.termsOfUseTitle)}
        className={iframeStyle}
      />
    </Modal>
  );
};

const iframeStyle = style({
  border: 0,
  display: "block",
  height: "60vh",
  width: "100%"
});
